<template lang="pug">
#sub-empresa-bloco-pesquisa-filtros
    .filtros
        .bloco-pesquisa-filtros__container
            .bloco-pesquisa-filtros__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    :placeholder='$t("mensagens.subEmpresaGestao.placehoder.pesquisaInteligente")',
                    autocomplete='off',
                    @keyup.enter='aplicarFiltros',
                    @input='limpar'
                )

        .filtros-data
            el-date-picker.input-data-cadastro(
                v-model='dataSelecionada',
                type='daterange',
                range-separator='-',
                format='dd/MM/yyyy',
                :clearable='false',
                :start-placeholder='$t("mensagens.subEmpresaGestao.placehoder.dataInicio")',
                :end-placeholder='$t("mensagens.subEmpresaGestao.placehoder.dataFim")',
                size='large',
                @change='aplicarFiltros'
            )

        section
            el-popover(
                placement='bottom',
                width='600',
                trigger='click',
                @show='obterDadosFiltro'
            )
                el-button.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) {{ $t('mensagens.subEmpresaGestao.placehoder.filtros') }}

                el-form(label-position='top')
                    .filtros-avancados__titulo
                        p {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.titulo') }}

                    .filtros-avancados__collapse
                        el-collapse(v-model='collapse', accordion)
                            el-collapse-item(
                                :title='$t("mensagens.subEmpresaGestao.filtrosAvancados.safra")',
                                name='safra'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='safraSelecionada',
                                    v-loading='carregandoSafra'
                                )
                                    el-checkbox.filtros-avancados__opcao(
                                        v-for='safra in safras',
                                        :label='safra.ano',
                                        :key='safra.id',
                                        :value='safra.ano',
                                        @change='aplicarFiltros'
                                    ) {{ safra.ano }}

                            el-collapse-item(
                                :title='$t("mensagens.subEmpresaGestao.filtrosAvancados.status")',
                                name='status'
                            )
                                el-checkbox-group.alinhamento-status.filtros-avancados__opcoes(
                                    v-model='statusSelecionado',
                                    v-loading='carregandoStatusEmpresa'
                                )
                                    el-checkbox.filtros-avancados__opcao(
                                        v-for='status in statusEmpresa',
                                        :label='status.descricao',
                                        :key='status.codigo',
                                        :value='status.descricao',
                                        @change='aplicarFiltros'
                                    ) {{ status.descricao }}

                            el-collapse-item.estados-municipios-filtro(
                                :title='$t("mensagens.subEmpresaGestao.filtrosAvancados.localidade")',
                                name='municipio'
                            )
                                .estados-filtro
                                    p.sub-titulo {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.selectDepartamento') }}
                                    el-select#estado(
                                        v-model='estadoSelecionado',
                                        :loading='carregandoEstados',
                                        @change='buscarMunicipios',
                                        @clear='limparEstado',
                                        clearable,
                                        filterable
                                    )
                                        el-option(
                                            v-for='{ sigla, id } in estados',
                                            :key='id + sigla',
                                            :id='"estado-" + sigla',
                                            :label='sigla',
                                            :value='id'
                                        )

                                .municipios-filtro
                                    p.sub-titulo {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.selectLocalidade') }}
                                    el-select#municipio(
                                        v-model='municipioSelecionado',
                                        multiple,
                                        :loading='carregandoMunicipios',
                                        :disabled='!estadoSelecionado',
                                        clearable,
                                        filterable,
                                        collapse-tags,
                                        @change='aplicarFiltros',
                                        @clear='removerFiltro(municipioSelecionado)'
                                    )
                                        el-option(
                                            v-for='{ nome, id } in municipios',
                                            :key='id + nome',
                                            :id='"municipio-" + id',
                                            :label='nome',
                                            :value='nome'
                                        )
                            el-collapse-item.estados-municipios-filtro(
                                :title='$t("mensagens.subEmpresaGestao.filtrosAvancados.fornecedores")',
                                name='fornecedor'
                            )
                                .fornecedor-filtro
                                    p.sub-titulo {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.selectFornecedores') }}
                                    el-select#fornecedor(
                                        v-model='fornecedorSelecionado',
                                        multiple,
                                        :loading='carregandoFornecedores',
                                        :disabled='!fornecedorSelecionado',
                                        clearable,
                                        filterable,
                                        collapse-tags,
                                        @change='aplicarFiltros',
                                        @clear='removerFiltro(fornecedorSelecionado)'
                                    )
                                        el-option(
                                            v-for='{ nome, id } in dadosFornecedores',
                                            :key='id + nome',
                                            :id='id',
                                            :label='nome',
                                            :value='id'
                                        )
                            el-collapse-item(
                                v-if='usuarioLogado.ambienteLogado === AmbientesEmpresas.BRASIL',
                                title='EUDR',
                                name='eudr'
                            )
                                el-select(
                                    v-model='eudrSelecionado',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    filterable,
                                    @change='aplicarFiltros'
                                )
                                    el-option(
                                        v-for='({ nome, id, value }, index) in eudr',
                                        :key='`eudr-${index}`',
                                        :id='`eudr-${index}`',
                                        :label='nome',
                                        :value='value'
                                    )

    .bloco-pesquisa-filtros__filtros-selecionados.mt-3(v-if='tags.length')
        span.filtros-selecionados__titulo {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.filtrosSelecionados') }}
        el-tag.filtros-selecionados__tags(
            v-for='(tag, index) in tags',
            :key='index',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ tag }}

        el-tag.filtros-selecionados__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.limparFiltros') }}
            i.el-icon-delete
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import LocalidadeService from '@/services/LocalidadeService';
import { mapGetters } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'BlocoPesquisaInteligenteFiltros',
    data() {
        return {
            AmbientesEmpresas,
            collapse: null,
            tags: [],
            statusEmpresa: [],
            safras: [],
            estados: [],
            municipios: [],
            dadosFornecedores: [],
            safraSelecionada: [],
            statusSelecionado: [],
            dataSelecionada: '',
            estadoSelecionado: '',
            municipioSelecionado: [],
            fornecedorSelecionado: [],
            eudrSelecionado: '',
            pesquisa: '',
            carregandoStatusEmpresa: false,
            carregandoSafra: false,
            carregandoEstados: false,
            carregandoMunicipios: false,
            carregandoFornecedores: false,
            eudr: [
                {
                    nome: this.$t('mensagens.comuns.sim'),
                    id: 1,
                    value: true
                },
                {
                    nome: this.$t('mensagens.comuns.nao'),
                    id: 2,
                    value: false
                }
            ]
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    methods: {
        adicionarTagEudr() {
            const sim = this.$t('mensagens.comuns.sim');
            const nao = this.$t('mensagens.comuns.nao');
            const eudrTagSim = `EUDR: ${sim}`;
            const eudrTagNao = `EUDR: ${nao}`;

            const tagJaAdicionada = this.tags.some(
                tag => tag === eudrTagSim || tag === eudrTagNao
            );

            if (!tagJaAdicionada) {
                this.tags.push(`EUDR: ${this.eudrSelecionado ? sim : nao}`);
            }
        },
        removerTagEudr() {
            const sim = this.$t('mensagens.comuns.sim');
            const nao = this.$t('mensagens.comuns.nao');
            const eudrTagSim = `EUDR: ${sim}`;
            const eudrTagNao = `EUDR: ${nao}`;

            this.eudrSelecionado = '';
            this.tags = this.tags.filter(
                tag => tag !== eudrTagSim && tag !== eudrTagNao
            );
        },

        aplicarFiltros() {
            this.tags = [];
            if (this.eudrSelecionado !== '') {
                this.adicionarTagEudr();
            }

            if (this.safras.length) this.tags.push(...this.safraSelecionada);
            if (this.statusSelecionado.length) {
                this.tags.push(...this.statusSelecionado);
            }
            if (this.dataSelecionada) this.tags.push('Data do contrato');

            if (this.municipioSelecionado.length) {
                this.municipioSelecionado.forEach(municipio => {
                    let estado = this.estados.find(estado => {
                        return estado.id === this.estadoSelecionado;
                    });
                    this.tags.push(estado.sigla + ' - ' + municipio);
                });
            }

            let idsFornecedores = [];
            if (this.fornecedorSelecionado.length) {
                this.fornecedorSelecionado.forEach(fornecedorId => {
                    if (
                        this.dadosFornecedores.some(
                            forn => parseInt(forn.id) === parseInt(fornecedorId)
                        )
                    ) {
                        let fornecedorObj = this.dadosFornecedores.find(
                            forn => parseInt(forn.id) === parseInt(fornecedorId)
                        );
                        this.tags.push(fornecedorObj.nome);
                        idsFornecedores.push(fornecedorId);
                    }
                });
            }

            const filtro = {
                safras: this.obterIdsSafra(),
                status: this.obterIdsStatus(),
                dataCadastroInicio: this.converterData(this.dataSelecionada[0]),
                dataCadastroFim: this.converterData(this.dataSelecionada[1]),
                pesquisa: this.obterPesquisa(),
                idMunicipio: this.obterIdsMunicipios(),
                idEstado: this.estadoSelecionado,
                idFornecedor: idsFornecedores,
                eudr: this.eudrSelecionado
            };
            this.$emit('emitFiltros', filtro);
        },
        converterData(date) {
            if (!this.dataSelecionada.length) return '';
            return new Date(date).getTime();
        },
        obterIdsStatus() {
            if (!this.statusSelecionado) return [];
            return this.statusSelecionado.map(descricao => {
                const statusObjeto = this.statusEmpresa.find(
                    objeto => objeto.descricao === descricao
                );
                return statusObjeto ? statusObjeto.codigo : null;
            });
        },
        obterIdsSafra() {
            if (!this.safraSelecionada) return [];
            return this.safraSelecionada.map(ano => {
                const statusObjeto = this.safras.find(
                    objeto => objeto.ano === ano
                );
                return statusObjeto ? statusObjeto.id : null;
            });
        },
        obterPesquisa() {
            if (!this.pesquisa) return '';
            return this.pesquisa;
        },
        limparFiltros() {
            this.removerTagEudr();
            this.tags = [];
            this.safraSelecionada = [];
            this.statusSelecionado = [];
            this.dataSelecionada = '';
            this.pesquisa = '';
            this.estadoSelecionado = '';
            this.municipioSelecionado = [];
            this.fornecedorSelecionado = [];
            this.aplicarFiltros();
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },

        desmarcarFiltroPopover(filtro) {
            const indexSafra = this.safraSelecionada.indexOf(filtro);
            if (indexSafra !== -1) {
                this.safraSelecionada.splice(indexSafra, 1);
            }

            const indexStatus = this.statusSelecionado.indexOf(filtro);
            if (indexStatus !== -1) {
                this.statusSelecionado.splice(indexStatus, 1);
            }

            if (filtro === 'Data do contrato') {
                this.dataSelecionada = '';
            }

            if (this.municipioSelecionado.length) {
                let municipio = filtro.split(' - ');
                const indexMunicipio = this.municipioSelecionado.indexOf(
                    municipio[1]
                );
                if (indexMunicipio !== -1) {
                    this.municipioSelecionado.splice(indexMunicipio, 1);
                    if (!this.municipioSelecionado.length) {
                        this.estadoSelecionado = null;
                    }
                }
            }

            if (this.fornecedorSelecionado.length) {
                const fornecedor = this.dadosFornecedores.find(
                    fornecedor => fornecedor.nome === filtro
                );

                const indexFornecedor = this.fornecedorSelecionado.indexOf(
                    fornecedor.id
                );

                if (indexFornecedor !== -1) {
                    this.fornecedorSelecionado.splice(indexFornecedor, 1);
                }
            }

            const filtroEudr = filtro.includes('EUDR');
            if (filtroEudr) {
                this.removerTagEudr();
            }
        },
        formatarData(data, formatDate) {
            if (data) {
                const dia = formatDate(data, 'dd');
                const mes = formatDate(data, 'MM');
                const ano = formatDate(data, 'yyyy');
                return `${dia}, ${mes}, ${ano}`;
            }
            return '';
        },
        limpar() {
            if (this.pesquisa === '') this.aplicarFiltros();
        },
        obterDadosFiltro() {
            if (this.statusEmpresa.length && this.safras.length) {
                return;
            }
            this.getStatusSubEmpresa();
            this.getSafras();
            this.buscarEstados();
            this.getFornecedoresOfflineSubEmpresa();
        },
        async getStatusSubEmpresa() {
            this.carregandoStatusEmpresa = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.statusSubEmpresa();

                const codigosParaRemover = [
                    'DISCREPANCIA',
                    'AJUSTADO_PELA_REVENDA',
                    'ARQUIVADO'
                ];

                this.statusEmpresa = data.filter(
                    status => !codigosParaRemover.includes(status.codigo)
                );
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de status.'
                });
            }
            this.carregandoStatusEmpresa = false;
        },
        async getSafras() {
            this.carregandoSafra = true;
            try {
                const { data } = await ContratoOriginacaoService.buscarSafras();
                this.safras = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de safras.'
                });
            }
            this.carregandoSafra = false;
        },
        async buscarEstados() {
            try {
                this.carregandoEstados = true;
                const { data } = await LocalidadeService.findEstados(false);

                this.estados = data;
                this.carregandoEstados = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os estados.');
            }
        },
        async buscarMunicipios() {
            this.municipioSelecionado = [];

            if (!this.estadoSelecionado) return;

            try {
                this.carregandoEstados = true;
                const { data } = await LocalidadeService.findMunicipios(
                    this.estadoSelecionado,
                    false
                );

                this.municipios = data;
                this.carregandoEstados = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os municipios.');
            }
        },
        async limparEstado() {
            if (this.municipioSelecionado.length) {
                this.municipioSelecionado.forEach(municipio => {
                    let estado = this.estados.find(estado => {
                        return estado.id === this.estadoSelecionado;
                    });
                    this.tags.splice(
                        this.tags.indexOf(estado.sigla + ' - ' + municipio),
                        1
                    );
                });
                this.estadoSelecionado = null;
                this.municipioSelecionado = [];
            }
            this.aplicarFiltros();
        },
        obterIdsMunicipios() {
            if (!this.municipioSelecionado) return [];
            return this.municipioSelecionado.map(nome => {
                const idObjeto = this.municipios.find(
                    objeto => objeto.nome === nome
                );
                return idObjeto ? idObjeto.id : null;
            });
        },
        municipioNome() {
            const nomeObjeto = this.municipios.find(
                objeto => objeto.id === this.municipioSelecionado
            );
            return nomeObjeto ? nomeObjeto.nome : null;
        },
        async getFornecedoresOfflineSubEmpresa() {
            this.carregandoFornecedores = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.getFornecedoresOfflineSubEmpresa();
                this.dadosFornecedores = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de status.'
                });
            }
            this.carregandoFornecedores = false;
        }
    }
};
</script>

<style lang="scss">
body {
    overflow-y: hidden;
    overflow-x: hidden;
}
.filtros {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    gap: 10px;
}

.bloco-pesquisa-filtros__container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
}

.filtros-data {
    box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
}

.input-data-cadastro {
    height: 43px !important;
    .el-input__inner {
        height: 43px !important;
    }
}

.bloco-pesquisa-filtros__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--gray);
        font-size: 16px;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.bloco-pesquisa-filtros__filtros-selecionados {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
}

.filtros-selecionados__limpar {
    cursor: pointer;
}

.filtros-avancados__titulo {
    color: var(--primary);
    font-weight: bold;
}

.filtros-avancados__opcoes {
    font-size: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.el-collapse-item.estados-municipios-filtro.is-active,
.el-collapse-item.estados-municipios-filtro {
    .el-collapse-item__content {
        display: flex;
        gap: 15px;
        padding-bottom: 25px;
        font-size: 13px;
        color: #303133;
        line-height: 1.7692307692;

        .sub-titulo {
            margin: 0;
            color: #808080;
        }

        .municipios-filtro,
        .estados-filtro {
            display: flex;
            flex-direction: column;
        }
    }
}

.expand-row {
    padding: 10px;
    display: flex;
    font-size: 13px;
    font-weight: 600;
    color: var(--primary);
    gap: 4px;
    .expand-row__title {
        margin-left: 48px;
        margin-bottom: 5px;
    }
    .expand-row__content {
        font-weight: 400;
        color: #606266;
    }
}
</style>
